import { DialogUtils, AppDialogExResult } from '@powerduck/common/dialog-utils';
import { AccountState } from "../../api/public/enums/accountState";
import { AppState } from '../../app-state';
import { AppConfig } from '../../app-config';
import { isNullOrEmpty } from '@powerduck/common/utils/is-null-or-empty';
import { PortalUtils as portalUtils } from '@powerduck/common/utils/utils';

export interface LoginDialogDisplayArgs {
    titleMessage?: string
    hideNewUser?: boolean
    hideThirdParty?: boolean
    callingComponent: any
    onLoggedIn?: (data: LoginDialogResponseData) => void
}

export interface LoginDialogDisplayElementArgs extends LoginDialogDisplayArgs {
    targetElement: HTMLElement
}

export interface LoginDialogResponseData {
    token: string
    userData: LoginDialogResponseUserData
}

export interface LoginDialogResponseUserData {
    IsSuperAdmin: boolean
    IsSystemOwner: boolean
    Email: string
    InvitonCardId: string
    DisplayName: string
    Name: string
    Surname: string
    AccountState: AccountState
    Identifier: string

}

export class LoginDialog {
    private static _currentHandle: AppDialogExResult<any> = null;
    private static _currentArgs: LoginDialogDisplayArgs = null;
    private static _currentRandomId: string = null;

    static show(args?: LoginDialogDisplayArgs) {
        let randomId = 'ifr-' + portalUtils.randomString(12);
        this.clearInstance();

        DialogUtils.showDialogEx({
            title: 'Login',
            autoHide: false,
            message: LoginDialog.getIframeUrl(randomId),
            buttons: []
        }).then((handle) => {
            LoginDialog.onAfterShown(args, handle, randomId);
        });
    }

    static showToElement(args?: LoginDialogDisplayElementArgs) {
        let randomId = 'ifr-' + portalUtils.randomString(12);
        this.clearInstance();
        args.targetElement.innerHTML = LoginDialog.getIframeUrl(randomId);
        this.onAfterShown(args, null, randomId);
    }

    private static getIframeUrl(randomId: string): string {
        return '<div style="height:510px;"><div id="' + LoginDialog.getBlockerId(randomId) + '">' + AppConfig.blockerHtml + '</div><iframe id="' + randomId + '" src="about:blank" style="height:510px;width:100%;border:0"></iframe></div>'
    }

    private static bindIframeUrlIntoForm(args: LoginDialogDisplayArgs, randomId: string) {
        $('#' + randomId).on('load', function () {
            LoginDialog.getBlockerJq().hide();
        } as any).attr('src', LoginDialog.buildIframeUrl(args))
    }

    private static getBlockerId(rootId: string): string {
        return 'blck' + rootId;
    }

    private static buildIframeUrl(args: LoginDialogDisplayArgs): string {
        let uriBuilder = '/login?iframe=modal&useMessaging=1&useScrollMessaging=0';
        if (!isNullOrEmpty(args?.titleMessage)) {
            uriBuilder += '&titleMessage=' + encodeURIComponent(args.titleMessage);
        }

        if (args?.hideNewUser != null) {
            uriBuilder += '&hideNewUser=1';
        }

        if (args?.hideThirdParty != null) {
            uriBuilder += '&hideThirdParty=1';
        }

        return uriBuilder;
    }

    private static onAfterShown(args: LoginDialogDisplayArgs, handle: AppDialogExResult<any>, randomId: string) {
        LoginDialog._currentHandle = handle;
        LoginDialog._currentArgs = args;
        LoginDialog._currentRandomId = randomId;
        LoginDialog.bindEvents();
        LoginDialog.bindIframeUrlIntoForm(args, randomId);
    }

    private static bindEvents() {
        LoginDialog.unbindEvents();
        window.addEventListener('message', this.onMessageReceived, false);
    }

    private static unbindEvents() {
        try {
            window.removeEventListener('message', this.onMessageReceived);
        } catch (e) { }
    }

    private static getBlockerJq(): JQuery {
        return $('#' + LoginDialog.getBlockerId(LoginDialog._currentRandomId));
    }

    private static clearInstance() {
        this.unbindEvents();
        this._currentArgs = null;
        this._currentHandle = null;
    }

    private static onMessageReceived(message: MessageEvent): void {
        var msgStr = (message as MessageEvent).data;
        if (msgStr != null && msgStr.indexOf('showLoading') > -1) {
            LoginDialog.getBlockerJq().show();
        } else if (msgStr != null && msgStr.indexOf('hideLoading') > -1) {
            LoginDialog.getBlockerJq().hide();
        } else if (msgStr != null && msgStr.indexOf('userLogged') > -1) {
            if (LoginDialog._currentArgs?.onLoggedIn != null) {
                let parsedData: LoginDialogResponseData = JSON.parse(msgStr.substring(4)).data
                let userData = parsedData.userData;
                let userDisplay: string;

                if (!isNullOrEmpty(userData.Name) && !isNullOrEmpty(userData.Surname)) {
                    userDisplay = userData.Name + " " + userData.Surname;
                } else if (isNullOrEmpty(userData.DisplayName)) {
                    userDisplay = userData.DisplayName;
                } else {
                    userDisplay = userData.Email;
                }

                AppState.setUser({
                    Email: userData.Email,
                    DisplayName: userDisplay
                });

                LoginDialog._currentArgs?.onLoggedIn(parsedData);
                let handle = this._currentHandle;
                LoginDialog.clearInstance();

                if (handle != null) {
                    handle.hideModal();
                }
            } else {
                LoginDialog._currentHandle.showLoading();
                setTimeout(() => {
                    location.reload();
                }, 250);
            }
        }
    }
}